<div class="incident-page min-vh-100 d-flex flex-column bg-transparent">
  <HomeNavBar />

  <section class="incident-feed-shell">
    <div class="container-fluid flex-grow-1">
      <div class="row gap-2 mt-2">

        <div class="col bg-transparent m-0 gap-2 rounded p-1">

          <div ref="incident_scroll_container" class="px-0 px-md-3 pb-3 scrollable-container h-100"
            @scroll.passive="handle_incident_feed_scroll">
            <div class="row gx-4 justify-content-between pb-extra pb-extra-desktop">

              <aside class="d-none d-lg-block col-lg-3 incident-profile-column">
                <div class="home-profile-rail incident-profile-rail">
                  <div class="home-profile-rail-dots">
                    <span></span>
                  </div>
                  <div class="home-profile-identity d-flex flex-column align-items-center text-align-center">
                    <div class="home-profile-art" aria-hidden="true">
                      <i class="bi bi-shield-exclamation"></i>
                    </div>
                    <div class="home-profile-avatar">
                      <img v-if="profileImage" :src="profileImage" alt="Profile">
                      <span v-else>{{ incident_profile_name.charAt(0) }}</span>
                    </div>
                    <h6 class="fw-bold">{{ incident_profile_name }}</h6>
                    <p>{{ incident_profile_handle }}</p>
                  </div>

                  <nav class="home-profile-menu" aria-label="Incident shortcuts">
                    <div v-for="item in incident_left_nav_items" :key="item.label">
                      <a v-if="item.href" :href="item.href" class="home-profile-menu-item"
                        :class="{ active: item.active }">
                        <i class="bi" :class="item.icon"></i>
                        <span>{{ item.label }}</span>
                      </a>
                      <button v-else type="button" class="home-profile-menu-item" :class="{ active: item.active }"
                        @click="handle_incident_left_nav_action(item)">
                        <i class="bi" :class="item.icon"></i>
                        <span>{{ item.label }}</span>
                      </button>
                    </div>
                  </nav>
                </div>
              </aside>

              <div class="col-12 col-lg-9">
                <!-- PAGE HEADER -->
                <div class="incident-feed-toolbar d-flex justify-content-between align-items-center gap-3 mb-3">

                  <div class="incident-composer-card card border rounded-4 p-1" data-bs-toggle="modal" data-bs-target="#incidentModal">
                    <div class="feed-composer-row rounded d-flex align-items-center gap-3">
                      <div class="feed-composer-avatar">
                        <img :src="profileImage || 'https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/user.webp'" alt="Profile">
                      </div>
                      <button type="button" class="feed-composer-prompt text-xxs flex-grow-1" aria-label="Create a post"
                        data-bs-toggle="modal" data-bs-target="#incidentModal">
                        <span>Report an incident or concern, {{ composer_display_name }}.</span>
                      </button>
                      <div class="feed-composer-actions d-none d-sm-flex">
                        <button type="button" class="feed-composer-action feed-composer-action-recording"
                          data-bs-toggle="modal" data-bs-target="#incidentModal" title="Recording">
                          <i class="bi bi-mic-fill action-icon"></i>
                        </button>
                        <button type="button" class="feed-composer-action feed-composer-action-media"
                          data-bs-toggle="modal" data-bs-target="#incidentModal" title="Images">
                          <i class="bi bi-image-fill action-icon"></i>
                        </button>
                        <button type="button" class="feed-composer-action feed-composer-action-video"
                          data-bs-toggle="modal" data-bs-target="#incidentModal" title="Video">
                          <i class="bi bi-play-btn-fill action-icon"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Right Controls -->
                  <div class="incident-toolbar-actions d-flex align-items-center gap-2">
                    <button
                      class="incident-icon-button btn btn-light border rounded-3 d-lg-none d-flex align-items-center justify-content-center position-relative"
                      type="button" title="Show incident map" @click="toggle_map">
                      <i class="bi bi-geo-alt-fill"></i>
                    </button>

                    <!-- Filter Dropdown -->
                    <div class="position-relative me-2" ref="incidentFilterDropdownRef">
                      <div class="d-flex align-items-center gap-1">
                        <button
                          class="incident-icon-button btn btn-light border rounded-4 d-flex align-items-center justify-content-center position-relative"
                          @click="filter_dropdown_open = !filter_dropdown_open" title="Filter incidents">
                          <i class="bi bi-funnel-fill"></i>

                          <span v-if="active_filter_count > 0"
                            class="incident-filter-count position-absolute top-0 start-100 translate-middle badge rounded bg-primary">
                            {{ active_filter_count }}
                          </span>
                        </button>
                      </div>
                      <!-- Dropdown -->
                      <div v-if="filter_dropdown_open"
                        class="incident-filter-dropdown position-absolute top-100 end-0 bg-white shadow rounded p-3 mt-2">

                        <!-- Header -->
                        <div class="d-flex justify-content-between align-items-center mb-3">
                          <span class="fw-600 text-sm">Filter Reports</span>

                          <div class="d-flex gap-2 align-items-center">
                            <button v-if="active_filter_count > 0" class="btn btn-link btn-sm text-danger p-0 text-xs"
                              @click="clear_all_filters">
                              Clear all
                            </button>

                            <button class="btn btn-sm btn-light px-2 py-1 incident-filter-close"
                              @click="filter_dropdown_open = false">
                              <i class="bi bi-x-lg"></i>
                            </button>
                          </div>
                        </div>

                        <!-- Search -->
                        <div class="mb-3">
                          <label class="text-xxs fw-600 text-uppercase text-muted mb-1 d-block">
                            Search
                          </label>

                          <div class="position-relative">
                            <i
                              class="bi bi-search position-absolute top-50 start-0 translate-middle-y ms-2 text-muted"></i>

                            <input v-model="search_query" type="text" class="form-control form-control-sm ps-4 rounded"
                              placeholder="Search by ID, keyword..." />
                          </div>
                        </div>

                        <hr class="my-2">

                        <!-- Status -->
                        <div class="mb-3">
                          <label class="text-xxs fw-600 text-uppercase text-muted mb-2 d-block">
                            Status
                          </label>

                          <div class="d-flex flex-wrap gap-1">
                            <span @click="filter_status = 'All'" class="badge rounded cursor-pointer text-xs"
                              :class="filter_status === 'All' ? 'status-active bg-primary text-white border border-primary' : 'status-inactive'">
                              All
                            </span>

                            <span v-for="step in workflow_steps" :key="step.status" @click="filter_status = step.status"
                              class="badge rounded cursor-pointer text-xs"
                              :class="filter_status === step.status ? 'status-active bg-primary text-white border border-primary' : 'status-inactive'">
                              {{ step.status }}
                            </span>
                          </div>
                        </div>

                        <hr class="my-2">

                        <!-- Incident Types -->
                        <div class="mb-3">
                          <label class="text-xxs fw-600 text-uppercase text-muted mb-2 d-block">
                            Incident Type
                          </label>

                          <div class="d-flex flex-wrap gap-1">
                            <span @click="filter_type = 'All'" class="badge rounded cursor-pointer text-xs"
                              :class="filter_type === 'All' ? 'status-active bg-primary text-white border border-primary' : 'status-inactive'">
                              All
                            </span>

                            <span v-for="type in entity_types" :key="type.id"
                              @click="filter_type = get_incident_type_filter_value(type)" class="badge rounded cursor-pointer text-xs"
                              :class="filter_type === get_incident_type_filter_value(type) ? 'status-active bg-primary text-white border border-primary' : 'status-inactive'">
                              {{ type.entity_type_name }}
                            </span>
                          </div>
                        </div>

                      </div>


                    </div>

                  </div>
                </div>
                <div v-if="show_map_view" class="incident-map-main">
                  <section class="incident-main-map-card card border shadow-sm">
                    <div class="incident-map-header d-flex align-items-center justify-content-between gap-3">
                      <div class="d-flex align-items-center gap-2 min-w-0">
                        <span class="incident-map-header-icon d-inline-flex align-items-center justify-content-center">
                          <i class="bi bi-geo-alt-fill"></i>
                        </span>
                        <div class="min-w-0">
                          <div class="fw-bold text-sm text-dark">Incident Map</div>
                          <div class="text-muted text-xxs">{{ filtered_entries.length }} visible reports</div>
                        </div>
                      </div>
                      <button class="btn btn-sm btn-light incident-menu-btn incident-map-list-btn" type="button" title="Back to reports"
                        @click="toggle_map">
                        <i class="bi bi-list-ul"></i>
                      </button>
                    </div>
                    <div class="incident-map-content">
                      <div id="incident-map" class="incident-map-container incident-map-container-main"></div>
                      <div class="incident-map-categories">
                        <button v-for="category in incident_category_counts" :key="category.name"
                          class="incident-map-category" type="button"
                          :class="{ 'is-active': is_incident_category_selected(category.name) }"
                          @click="select_map_category(category.name)">
                          <span class="incident-map-category-pin" :style="{ backgroundColor: category.color }"></span>
                          <span class="incident-map-category-name">{{ category.name }}</span>
                          <span class="incident-map-category-count">{{ category.count }}</span>
                        </button>
                      </div>
                    </div>
                  </section>
                </div>
                <div v-else>
                  <div v-if="loading && logged_entries.length === 0" class="text-center justify-content-center">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <div class="mt-2 text-muted small">Fetching reports...</div>
                  </div>

                  <div v-else-if="filtered_entries.length === 0" class="rounded-3 text-center p-4">
                    <div class="incident-empty-feed-icon mb-3 mx-auto">
                      <i class="bi bi-search"></i>
                    </div>
                    <div class="fw-bold text-dark text-sm">No reports found</div>
                    <div class="small text-muted mt-1">Try adjusting your search or filters.</div>
                  </div>

                  <div v-else>
                    <div class="row g-3 justify-content-center">
                      <div v-for="r in filtered_entries" :key="r.id" class="col-12">
                        <article class="incident-report-card card border shadow-sm rounded w-100 overflow-hidden h-100">

                          <!-- Top badges + remaining -->
                          <div class="incident-report-header d-flex flex-row justify-content-between align-items-center align-items-sm-start gap-3 px-3 pt-3">
                            <div class="min-vw-0 d-flex align-items-start gap-3">
                              <div class="min-vw-0">
                                <div class="incident-header-identity d-flex flex-nowrap align-items-center min-vw-0 mb-1">
                                  <span class="incident-header-code me-2 text-xxs fw-bold text-nowrap">{{ r.ref_number }}</span>
                                  <span class="incident-header-status d-inline-flex align-items-center gap-1 text-xxs text-nowrap fw-bold" :class="`is-${get_incident_status_key(r)}`">
                                    {{ get_current_status_label(r) }}
                                  </span>
                                  <span class="incident-header-type ms-2 text-capitalize text-xxs text-secondary me-2 fw-semibold">
                                    {{ r.entity_type?.entity_type_name || r.incident_type?.entity_type_name || 'Incident' }}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div class="d-flex align-items-center gap-2 flex-shrink-0">
                              <div v-if="get_remaining_label(r)"
                                class="incident-remaining d-flex align-items-center gap-1">
                                <i class="bi bi-clock-history"></i>
                                <span class="text-nowrap">{{ get_remaining_label(r) }}</span>
                              </div>
                              <div class="dropend" @click.stop v-if="can_edit_incident(r)">
                                <button class="btn btn-sm btn-light incident-menu-btn" type="button"
                                  data-bs-toggle="dropdown" aria-expanded="false" aria-label="Incident actions">
                                  <i class="bi bi-three-dots"></i>
                                </button>
                                <ul class="dropdown-menu custom-dropdown lh-1">
                                  <li>
                                    <a class="dropdown-item text-xxs fw-bold" href=""
                                      @click.prevent="start_edit_incident_report(r)">
                                      Edit
                                    </a>
                                  </li>
                                  <li>
                                    <a class="dropdown-item text-xxs fw-bold" href=""
                                      @click.prevent="delete_incident_report(r)">
                                     Delete
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <!-- Title + description -->
                          <div class="incident-report-body">
                            <div class="incident-report-meta-grid mt-1">
                              <div class="min-vw-0">
                                <div class="incident-report-meta-label text-xxs">
                                  <i class="bi bi-geo-alt me-2 flex-shrink-0" aria-hidden="true"></i>
                                  <span class="fw-bold">Location</span>
                                </div>
                                <div class="text-xxs">{{ r.location || 'Location not provided' }}</div>
                              </div>
                              <div class="min-vw-0">
                                <div class="incident-report-meta-label text-xxs">
                                  <i class="bi bi-person me-2 flex-shrink-0" aria-hidden="true"></i>
                                  <span class="fw-bold">Reported by</span>
                                </div>
                                <div class="text-xxs">{{ get_reporter_name(r) }}</div>
                              </div>
                              <div class="min-vw-0">
                                <div class="incident-report-meta-label d-flex align-items-center justify-content-between gap-2 text-xxs">
                                  <div class="d-flex align-items-center min-vw-0">
                                    <i class="bi bi-person me-2 flex-shrink-0" aria-hidden="true"></i>
                                    <span class="fw-bold">Assigned to</span>
                                  </div>
                                  <button v-if="can_assign_incident_reports" type="button"
                                    class="btn btn-sm btn-primary text-xxs rounded px-3 py-1"
                                    @click.stop="go_to_incident_assignment(r)">
                                    {{ is_incident_assigned(r) ? 'Reassign' : 'Assign' }}
                                  </button>
                                </div>
                                <div class="text-xxs">{{ get_assigned_name(r) }}</div>
                              </div>
                            </div>
                           <div v-if="get_report_body(r)"
                             class="incident-desc incident-report-description d-block bg-white border border-dark rounded-2 text-xxs my-3 px-3 py-2">
                              {{ get_report_body(r) }}
                            </div>
                          </div>

                          <!-- Current status (compact) -->
                          <div class="d-flex align-items-center justify-content-between gap-2 pe-3">
                            <button class="btn btn-sm btn-light incident-menu-btn ms-auto" type="button"
                              aria-label="Toggle incident tracking" @click.stop="toggle_activity(r.id)"
                              :class="is_activity_open(r.id) ? 'is-open' : ''">
                              <i class="bi bi-chevron-down"></i>
                            </button>
                          </div>

                          <!-- Audit trail (expanded) -->
                          <div v-if="is_activity_open(r.id)" class="mx-3 mt-2 pt-2 pb-3 incident-trail">
                            <div class="text-xxs fw-bold text-muted mb-2">
                              Incident Tracking
                            </div>

                            <div class="incident-trail-body">
                              <div class="incident-trail-line"></div>

                              <div v-if="get_incident_progress_history(r).length">
                                <div v-for="step in get_upcoming_incident_progress_steps(r)"
                                  :key="`upcoming-${step.key}`"
                                  class="incident-trail-item is-upcoming d-flex align-items-start"
                                  :data-step="step.key">
                                  <div class="incident-trail-icon d-flex align-items-center justify-content-center">
                                    <i class="bi bi-circle-fill"></i>
                                  </div>
                                  <div class="incident-trail-content">
                                    <div class="incident-trail-label fw-semibold">
                                      {{ step.label }}
                                    </div>
                                  </div>
                                </div>

                                <div v-for="progress in get_incident_progress_history(r)" :key="progress.id"
                                  class="incident-trail-item is-done d-flex align-items-start"
                                  :data-step="progress.status?.name"
                                  :data-action="progress.action_type">
                                  <div class="incident-trail-icon d-flex align-items-center justify-content-center">
                                    <i class="bi bi-circle-fill"></i>
                                  </div>
                                  <div class="incident-trail-content">
                                    <div class="incident-trail-label fw-semibold">
                                      {{ get_incident_progress_title(progress) }}
                                    </div>
                                    <div class="incident-trail-time text-muted">
                                      {{ format_incident_tracking_time(progress.created_at) }}
                                      &middot; {{ get_incident_progress_actor(progress) }}
                                    </div>
                                    <div v-if="progress.note" class="text-xxs fst-italic">
                                      {{ progress.note }}
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div v-else>
                              <div class="incident-trail-item is-done d-flex align-items-start">
                                <div class="incident-trail-icon d-flex align-items-center justify-content-center">
                                  <i class="bi bi-check-lg"></i>
                                </div>
                                <div class="incident-trail-content">
                                  <div class="incident-trail-label fw-bold">Submitted</div>
                                  <div class="incident-trail-time text-muted">
                                    {{ format_incident_tracking_time(r.date_created) }} &middot; {{ get_reporter_name(r) }}
                                  </div>
                                </div>
                              </div>

                              <div v-for="(step, index) in workflow_display_steps" :key="step.key"
                                class="incident-trail-item d-flex align-items-start" :data-step="step.key" :class="get_step_class(r, index)">
                                <div class="incident-trail-icon d-flex align-items-center justify-content-center">
                                  <i v-if="index < get_display_step_index(r)" class="bi bi-check-lg"></i>
                                  <i v-else :class="step.icon"></i>
                                </div>
                                <div class="incident-trail-content">
                                  <div class="incident-trail-label fw-semibold">{{ step.label }}</div>
                                  <div
                                    v-if="step.key !== 'pending' && (step.key === 'assigned' || index === get_display_step_index(r)) && get_incident_step_timestamp(r, step.key)"
                                    class="incident-trail-time text-muted">
                                    {{ format_incident_tracking_time(get_incident_step_timestamp(r, step.key)) }}<template v-if="step.key === 'assigned'"> &middot; {{ get_assigned_name(r) }}</template>
                                  </div>
                                </div>
                              </div>
                              </div>

                            </div>
                          </div>

                          <div v-if="get_attachment_count(r)" class="incident-feed-attachments px-3 pb-3 mt-0">
                            <div
                              v-for="(attachment, attachment_index) in get_visible_incident_images(r)"
                              :key="`${attachment.name}-${attachment.url}`"
                            >
                              <button
                                type="button"
                                class="incident-feed-attachment incident-feed-attachment-image"
                                @click.stop="open_incident_image_modal(attachment, r)"
                              >
                                <img
                                  :src="attachment.url"
                                  :alt="attachment.name"
                                  class="incident-feed-attachment-preview"
                                  loading="lazy"
                                >
                                <span
                                  v-if="attachment_index === 3 && get_incident_extra_image_count(r)"
                                  class="incident-feed-attachment-more"
                                >
                                  +{{ get_incident_extra_image_count(r) }}
                                </span>
                              </button>
                            </div>
                            <div
                              v-for="attachment in get_incident_file_attachments(r)"
                              :key="`${attachment.name}-${attachment.url}`"
                            >
                              <a
                                class="incident-feed-attachment incident-feed-file-attachment flex-column justify-content-center gap-1 p-2 overflow-hidden bg-light rounded-3"
                                :class="{ 'is-disabled': !attachment.url }"
                                :href="attachment.url || undefined"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <i class="bi flex-shrink-0 fs-5" :class="attachment.icon"></i>
                                <span class="incident-feed-file-name d-block w-100 text-truncate text-center">{{ attachment.name }}</span>
                              </a>
                            </div>
                          </div>
                          

                          <!-- Social action row -->
                          <div class="incident-social-row border-top px-2 py-1">
                            <div class="row g-0 align-items-center">
                              <div class="col-4">
                                <button type="button" class="incident-social-action btn d-flex align-items-center justify-content-center gap-1 w-100 border-0"
                                  :class="{ 'is-liked': is_incident_liked(r) }"
                                  @click.stop="toggle_incident_like(r)">
                                  <i class="bi"
                                    :class="is_incident_liked(r) ? 'bi-hand-thumbs-up-fill' : 'bi-hand-thumbs-up'"></i>
                                  <span>{{ get_incident_like_count(r) }}</span>
                                </button>
                              </div>

                              <div class="col-4">
                                <button type="button" class="incident-social-action btn d-flex align-items-center justify-content-center gap-1 w-100 border-0"
                                  @click.stop="toggle_comment_panel(r.id)">
                                  <i class="bi bi-chat"></i>
                                  <span>{{ get_incident_comment_count(r) }}</span>
                                </button>
                              </div>

                              <div class="col-4 position-relative">
                                <button type="button" class="incident-social-action btn d-flex align-items-center justify-content-center gap-1 w-100 border-0"
                                  @click.stop="toggle_share_menu(r.id)">
                                  <i class="bi bi-share"></i>
                                  <span>Share</span>
                                </button>

                                <div v-if="is_share_menu_open(r.id)" class="incident-share-popover shadow-sm"
                                  @click.stop>
                                  <button type="button" class="incident-share-item" @click="copy_incident_link(r)">
                                    <i class="bi bi-link-45deg text-primary"></i>
                                    <span>Copy link</span>
                                  </button>
                                  <a class="incident-share-item" target="_blank"
                                    :href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(get_incident_url(r))">
                                    <i class="bi bi-facebook text-primary"></i>
                                    <span>Facebook</span>
                                  </a>
                                  <a class="incident-share-item" target="_blank"
                                    :href="'https://api.whatsapp.com/send?text=' + encodeURIComponent(get_incident_url(r))">
                                    <i class="bi bi-whatsapp text-success"></i>
                                    <span>WhatsApp</span>
                                  </a>
                                  <a class="incident-share-item" target="_blank"
                                    :href="'mailto:?subject=Incident%20Report&body=' + encodeURIComponent(get_incident_url(r))">
                                    <i class="bi bi-envelope text-secondary"></i>
                                    <span>Email</span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Comments preview -->
                          <div v-if="is_comment_panel_open(r.id)">
                            <div class="text-xxs fw-bold ms-2 mb-1">Comments</div>
                            <div v-if="get_incident_comments(r).length" class="d-flex flex-column gap-3">
                              <IncidentCommentItem v-for="comment in get_visible_incident_comments(r)"
                                :key="comment.id" :comment="comment" :report="r"
                                :controller="incident_comment_controller" />
                              <button v-if="has_more_incident_comments(r)" type="button"
                                class="btn btn-link align-self-center text-decoration-none text-xxs fw-bold p-0"
                                @click.stop="toggle_incident_comments(r.id)">
                                {{ are_incident_comments_expanded(r.id) ? 'Show less' : 'See more comments' }}
                              </button>
                            </div>
                            <div v-else class="text-muted text-xs py-2">
                              No comments yet.
                            </div>

                            <div class="d-flex align-items-center gap-2 m-2">
                              <div class="incident-comment-composer-avatar d-flex align-items-center justify-content-center rounded-circle overflow-hidden fw-bold">
                                <img v-if="profileImage || user_details.profile_picture"
                                  class="w-100 h-100 object-fit-cover"
                                  :src="profileImage || user_details.profile_picture" :alt="incident_profile_name">
                                <span v-else>{{ incident_profile_initials }}</span>
                              </div>
                              <input class="form-control form-control-sm rounded-pill incident-comment-input"
                                type="text" v-model="comment_drafts[r.id]" placeholder="Write a comment..."
                                :data-incident-comment-input="r.id"
                                @keyup.enter="submit_incident_comment(r)" />
                              <button class="btn btn-sm btn-primary rounded-circle incident-send-btn" type="button"
                                @click="submit_incident_comment(r)">
                                <i class="bi bi-send-fill"></i>
                              </button>
                            </div>
                          </div>
                        </article>
                      </div>
                    </div>
                    <div v-if="incident_loading_more" class="d-flex justify-content-center align-items-center py-3 text-muted text-xs">
                      <span class="spinner-border spinner-border-sm text-primary me-2" role="status" aria-hidden="true"></span>
                      Loading more...
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  </section>


</div>

<teleport to="body">
  <div class="modal fade incident-image-preview-modal" id="incidentImagePreviewModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content rounded shadow">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xxs fw-500 mb-0">
            {{ selected_incident_image?.name || 'Incident attachment' }}
          </p>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body p-3">
          <div class="incident-image-preview-shell">
            <button
              v-if="selected_incident_images.length > 1"
              type="button"
              class="incident-image-preview-nav incident-image-preview-nav-prev"
              aria-label="Previous image"
              @click="show_previous_incident_image"
            >
              <i class="bi bi-chevron-left"></i>
            </button>
            <img
              v-if="selected_incident_image"
              :src="selected_incident_image.url"
              :alt="selected_incident_image.name"
              class="incident-image-preview-img"
            >
            <button
              v-if="selected_incident_images.length > 1"
              type="button"
              class="incident-image-preview-nav incident-image-preview-nav-next"
              aria-label="Next image"
              @click="show_next_incident_image"
            >
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>
          <div
            v-if="selected_incident_images.length > 1"
            class="incident-image-preview-counter text-center text-muted text-xxs mt-2"
          >
            {{ selected_incident_image_index + 1 }} of {{ selected_incident_images.length }}
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>
<!-- Create Report Modal -->
<div class="modal fade incident-modal" id="incidentModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">

      <!-- LEFT SIDEBAR -->
      <div class="left-panel">
        <div class="left-header">
          <div class="tag-p">Incident logging</div>
          <div class="incident-modal-note">Choose the type that best matches the report.</div>
        </div>
        <div class="cat-label">Incident Type</div>

        <!-- Sidebar entity buttons -->
        <div class="type-list">
          <button v-for="type in entity_types" :key="type.id" class="type-btn"
            :class="[selected_type_id === type.id ? 'active' : '', editing_incident_report_id ? 'is-disabled' : '']"
            :disabled="!!editing_incident_report_id" @click="selected_type_id = type.id"
            :style="type.color ? { '--type-color': type.color } : {}">
            <div
              class="a-bar"
              :class="{ 'bg-secondary': !type.color }"
              :style="type.color ? { backgroundColor: type.color } : {}"
            ></div>
            <span
              v-if="get_incident_type_file_url(type) || type.icon"
              class="type-icon d-inline-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
              :style="{
                color: type.color || 'inherit',
                backgroundColor: type.color ? `${type.color}20` : 'transparent'
              }"
            >
              <img
                v-if="get_incident_type_file_url(type)"
                :src="get_incident_type_file_url(type)"
                :alt="`${type.entity_type_name} icon`"
                class="incident-type-card-image"
              >
              <i v-else class="bi" :class="type.icon"></i>
            </span>
            <div>
              <div class="t-name">{{ type.entity_type_name }}</div>
              <div class="t-sub">{{ type.sub || '' }}</div>
            </div>

          </button>
        </div>

        <div v-if="!editing_incident_report_id" class="incident-new-type-wrap">
          <button
            v-if="!show_new_type_form"
            type="button"
            class="incident-new-type-trigger"
            @click="toggle_new_type_form"
          >
            <i class="bi bi-plus-lg"></i>
            <span>New type</span>
          </button>

          <div v-else class="incident-new-type-form">
            <input
              v-model.trim="type_form.name"
              type="text"
              class="form-control incident-new-type-name"
              placeholder="Type name"
              @input="new_type_error = ''"
            >

            <div class="incident-new-type-label fw-bold">Choose icon</div>
            <div class="incident-new-type-help">
              Select an icon below, or upload your own custom image.
            </div>
            <div class="incident-new-type-icons">
              <button
                v-for="icon_option in available_icons"
                :key="icon_option.value"
                type="button"
                class="incident-new-type-icon"
                :class="{ active: is_icon_option_selected(icon_option) }"
                :aria-label="icon_option.name"
                @click="select_icon_option(icon_option)"
              >
                <img
                  v-if="icon_option.uploaded"
                  :src="icon_option.value"
                  :alt="icon_option.name"
                  class="incident-new-type-custom-icon"
                >
                <i v-else class="bi" :class="icon_option.value"></i>
              </button>
            </div>

            <button
              type="button"
              class="incident-new-type-upload"
              aria-label="Upload your own icon"
              title="Upload your own icon"
              @click="$refs.inlineIncidentTypeFile.click()"
            >
              <i class="bi bi-cloud-arrow-up"></i>
              <span>Upload your own icon</span>
              <small>PNG, JPG or SVG</small>
            </button>
            <input
              ref="inlineIncidentTypeFile"
              type="file"
              class="d-none"
              accept=".png,.jpg,.jpeg,.svg,image/png,image/jpeg,image/svg+xml"
              @change="handle_icon_upload"
            >

            <div class="incident-new-type-label fw-bold">
              Choose colour <span class="text-danger">*</span>
            </div>
            <div class="incident-new-type-color-row">
              <label
                class="incident-new-type-color-picker"
                :style="{ backgroundColor: type_form.color }"
              >
                <i class="bi bi-eyedropper"></i>
                <input
                  v-model="type_form.color"
                  type="color"
                  aria-label="Choose incident type colour"
                >
              </label>
              <input
                v-model.trim="type_form.color"
                type="text"
                class="form-control incident-new-type-hex"
                maxlength="7"
                placeholder="#0d6efd"
              >
              <span class="incident-new-type-help mb-0">Choose any colour</span>
            </div>

            <div v-if="new_type_error" class="text-danger text-xxs mt-2">
              {{ new_type_error }}
            </div>

            <div class="d-flex gap-2 mt-3">
              <button
                type="button"
                class="btn btn-primary btn-small rounded"
                :disabled="saving_incident_type || !type_form.name.trim()"
                @click="create_inline_incident_type"
              >
                {{ saving_incident_type ? "Adding..." : "Add" }}
              </button>
              <button
                type="button"
                class="btn btn-danger btn-sm rounded"
                :disabled="saving_incident_type"
                @click="reset_new_type_form"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- RIGHT PANEL -->
      <div class="right-panel"
        :style="{ '--accent': (entity_types.find(e => e.id === selected_type_id)?.color || '#0d6efd') }">

        <!-- Topbar -->
        <div class="modal-topbar">
          <div class="d-flex align-items-center">
            <div class="incident-modal-icon me-3">
              <i class="bi bi-clipboard2-plus-fill"></i>
            </div>
            <div>
              <div class="topbar-name ">
                {{ selected_type_id ? entity_types.find(e => e.id === selected_type_id)?.entity_type_name : 'New Incident' }}
              </div>
              <div class="topbar-desc ">
                {{ selected_type_id ? 'Complete the required details and submit the report.' : 'Choose an incident type to start logging.' }}
              </div>
            </div>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="form-scroll">
          <!-- EMPTY STATE -->
          <div v-if="!selected_type_id" class="empty-notice">
            <div class="incident-empty-icon mb-3">
              <i class="bi bi-list-check"></i>
            </div>
            <div class="fw-bold mb-1">Choose an Incident Type</div>
            <div class="small text-primary mb-3">
              Select from the sidebar or pick a type below to load the right form.
            </div>

            <!-- Quick pick grid -->
            <div class="type-grid px-2 pb-4">
              <button v-for="type in entity_types" :key="type.id" class="tg-item"
                :class="[selected_type_id === type.id ? 'active' : '', editing_incident_report_id ? 'is-disabled' : '']"
                :disabled="!!editing_incident_report_id" @click="selected_type_id = type.id"
                :style="type.color ? { '--tc': type.color, '--tbg': type.bg || `${type.color}12` } : {}">
                <span
                  v-if="get_incident_type_file_url(type) || type.icon"
                  class="tg-icon d-inline-flex align-items-center justify-content-center rounded-circle"
                  :style="{
                    color: type.color || 'inherit',
                    backgroundColor: type.color ? `${type.color}20` : 'transparent'
                  }"
                >
                  <img
                    v-if="get_incident_type_file_url(type)"
                    :src="get_incident_type_file_url(type)"
                    :alt="`${type.entity_type_name} icon`"
                    class="incident-type-card-image"
                  >
                  <i v-else class="bi" :class="type.icon"></i>
                </span>
                <span class="tg-lbl">{{ type.entity_type_name }}</span>
              </button>
              <button
                v-if="!editing_incident_report_id"
                type="button"
                class="tg-item incident-new-type-grid-button"
                :class="{ active: show_new_type_form }"
                @click="toggle_new_type_form"
              >
                <span class="">
                  <i class="bi bi-plus-lg"></i>
                </span>
                <span class="tg-lbl">New type</span>
              </button>
            </div>

            <div v-if="show_new_type_form" class="incident-new-type-mobile-form">
              <div class="text-start">
                <div class="fw-bold mb-1">Add your incident type</div>
                <div class="text-muted text-xs mb-3">
                  Give the type a name, icon and colour.
                </div>
              </div>

              <input
                v-model.trim="type_form.name"
                type="text"
                class="form-control incident-new-type-name"
                placeholder="e.g. Telecommunications"
                @input="new_type_error = ''"
              >

              <div class="incident-new-type-label text-start fw-bold">Choose icon</div>
              <div class="incident-new-type-icons">
                <button
                  v-for="icon_option in available_icons"
                  :key="icon_option.value"
                  type="button"
                  class="incident-new-type-icon"
                  :class="{ active: is_icon_option_selected(icon_option) }"
                  :aria-label="icon_option.name"
                  @click="select_icon_option(icon_option)"
                >
                  <img
                    v-if="icon_option.uploaded"
                    :src="icon_option.value"
                    :alt="icon_option.name"
                    class="incident-new-type-custom-icon"
                  >
                  <i v-else class="bi" :class="icon_option.value"></i>
                </button>
              </div>

              <button
                type="button"
                class="incident-new-type-upload"
                aria-label="Upload your own icon"
                title="Upload your own icon"
                @click="$refs.mobileIncidentTypeFile.click()"
              >
                <i class="bi bi-cloud-arrow-up"></i>
                <span>Upload your own icon</span>
                <small>PNG, JPG or SVG</small>
              </button>
              <input
                ref="mobileIncidentTypeFile"
                type="file"
                class="d-none"
                accept=".png,.jpg,.jpeg,.svg,image/png,image/jpeg,image/svg+xml"
                @change="handle_icon_upload"
              >

              <div class="incident-new-type-label text-start fw-bold">
                Choose colour <span class="text-danger">*</span>
              </div>
              <div class="incident-new-type-color-row">
                <label
                  class="incident-new-type-color-picker"
                  :style="{ backgroundColor: type_form.color }"
                >
                  <i class="bi bi-eyedropper"></i>
                  <input v-model="type_form.color" type="color" aria-label="Choose incident type colour">
                </label>
                <input
                  v-model.trim="type_form.color"
                  type="text"
                  class="form-control incident-new-type-hex"
                  maxlength="7"
                  placeholder="#0d6efd"
                >
              </div>

              <div v-if="new_type_error" class="text-danger text-xs text-start mt-2">
                {{ new_type_error }}
              </div>

              <div class="d-flex gap-2 mt-3">
                <button
                  type="button"
                  class="btn btn-primary btn-small rounded"
                  :disabled="saving_incident_type || !type_form.name.trim()"
                  @click="create_inline_incident_type"
                >
                  {{ saving_incident_type ? "Adding..." : "Add" }}
                </button>
                <button
                  type="button"
                  class="btn btn-danger btn-sm rounded"
                  :disabled="saving_incident_type"
                  @click="reset_new_type_form"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>

          <!-- FORM -->
          <div v-if="selected_type_id">
            <div v-for="section in form_schema" :key="section.id" class="form-section">
              <div class="sec-head">
                <div class="sec-ico">
                  <i class="bi bi-card-checklist"></i>
                </div>
                <div>
                  <div class="sec-title">{{ section.name }}</div>
                  <div class="sec-sub">{{ section.sub }}</div>
                </div>
              </div>
              <div class="sec-body">
                <div class="row g-3">
                  <div class="col-12" v-for="q in section.questions" :key="q.section_question_id">


                    <div
                      v-if="q.question_type.question_type === 'short_text' && q.question_text.toLowerCase().includes('location')">
                      <label class="incident-field-label">{{ q.question_text }}<span class="text-danger">*</span></label>
                      <div class="incident-location-search position-relative mb-2">
                        <i class="bi bi-search"></i>
                        <input :id="'search-input-' + q.section_question_id" type="text"
                          class="form-control border rounded"
                          :class="{ 'is-invalid': form_errors[q.section_question_id] }"
                          v-model="form_data[q.section_question_id]"
                          @input="clear_field_error(q.section_question_id)"
                          placeholder="Search for a location..." />
                      </div>
                      <div v-if="form_errors[q.section_question_id]" class="text-danger text-xs mb-2">
                        {{ form_errors[q.section_question_id] }}
                      </div>

                      <div :id="'map-' + q.section_question_id" class="rounded-4 mb-3 d-none location-map incident-location-map"></div>
                    </div>

                    <!-- SHORT TEXT -->
                    <div v-else-if="q.question_type.question_type === 'short_text'">
                      <label class="incident-field-label">{{ q.question_text }}</label>
                      <input type="text" class="form-control border rounded"
                        v-model="form_data[q.section_question_id]" />
                    </div>



                    <!-- LONG TEXT -->
                    <div v-else-if="q.question_type.question_type === 'long_text'">
                      <label class="incident-field-label">{{ q.question_text }}<span class="text-danger">*</span></label>
                      <textarea class="form-control" :class="{ 'is-invalid': form_errors[q.section_question_id] }"
                        v-model="form_data[q.section_question_id]"
                        @input="clear_field_error(q.section_question_id)"></textarea>
                      <div v-if="form_errors[q.section_question_id]" class="text-danger text-xs mt-1">
                        {{ form_errors[q.section_question_id] }}
                      </div>
                    </div>

                    <!-- SELECT -->
                    <div v-else-if="q.question_type.question_type === 'select'">
                      <label class="incident-field-label">{{ q.question_text }}</label>
                      <select class="form-select" v-model="form_data[q.section_question_id]">
                        <option value="">Select...</option>
                        <option v-for="opt in q.multi_select_choices" :key="opt.id" :value="opt.value">
                          {{ opt.value }}
                        </option>
                      </select>
                    </div>

                    <!-- FILE UPLOAD -->
                    <div v-else-if="q.question_type.question_type === 'file'">
                      <label class="incident-field-label">{{ q.question_text }}</label>



                      <div
                        class="drop-zone-stable d-flex align-items-center justify-content-center pointer border-2 rounded-4 p-3 mb-3 text-center transition-all position-relative"
                        :class="isDragging ? 'border-primary bg-primary-subtle' : 'border-dashed'"
                        @dragover.prevent="isDragging = true" @dragenter.prevent="isDragging = true"
                        @dragleave.prevent="isDragging = false"
                        @drop.prevent="handle_file_upload($event, q.section_question_id)" @click="trigger_file_input">
                        <div class="d-flex align-items-center justify-content-center gap-2 h-100">
                          <i class="bi bi-cloud-plus-fill text-primary fs-4"></i>
                          <span class="fw-bold text-black text-sm">Drag & Drop media here or click</span>
                        </div>

                        <input type="file" ref="fileInput" class="d-none" multiple
                          @change="handle_file_upload($event, q.section_question_id)">
                      </div>

                      <div v-if="form_data[q.section_question_id] && form_data[q.section_question_id].length > 0"
                        class="d-flex flex-wrap gap-3 mb-3 px-1 w-100">

                        <div v-for="(file, index) in form_data[q.section_question_id]" :key="index"
                          class="preview-item position-relative mb-2">

                          <img v-if="file.type && file.type.startsWith('image/')" :src="file.previewUrl"
                            class="w-100 h-100 rounded" :alt="file.name">
                          <div v-else-if="file.type && file.type.startsWith('video/')" class="position-relative w-100 h-100">
                            <video class="preview-video rounded border">
                              <source :src="file.previewUrl" :type="file.type" />
                            </video>
                            <i class="bi bi-play-circle-fill position-absolute top-50 start-50 translate-middle text-white fs-3 opacity-75"></i>
                          </div>

                          <div v-else class="preview-item rounded-3 border bg-light d-flex flex-column align-items-center justify-content-center text-center p-1">
                            <i v-if="file?.display_name?.endsWith('.pdf')" class="bi bi-file-earmark-pdf-fill text-danger fs-2"></i>
                            <i v-else-if="file?.display_name?.endsWith('.doc') || file?.display_name?.endsWith('.docx')" class="bi bi-file-earmark-word-fill text-primary fs-2"></i>
                            <i v-else-if="file?.display_name?.endsWith('.xls') || file?.display_name?.endsWith('.xlsx')" class="bi bi-file-earmark-excel-fill text-success fs-2"></i>
                            <i v-else class="bi bi-file-earmark-text-fill text-secondary fs-2"></i>

                          <span class="text-xxs text-truncate w-100 px-1">{{ file.name }}</span>
                        </div>

                          <button type="button"
                            class="btn btn-sm btn-danger fw-bold position-absolute top-0 end-0 fs-6 px-2 py-0"
                            @click="remove_file(q.section_question_id, index)">
                            &times;
                          </button>

                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Footer -->
        <div v-if="selected_type_id" class="modal-footer-bar d-flex justify-content-end">
          <button class="btn btn-sm btn-primary rounded" :disabled="is_submitting" @click="submit_incident">
            <span>{{ is_submitting ? "Submitting..." : (editing_incident_report_id ? "Update Report" : "Submit Report") }}</span>
          </button>
        </div>

      </div>
    </div>
  </div>
</div>
